import React from "react"
import { IconButton, CircularProgress } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"

export const ExportButton = ({
  disabled = false,
  isFetching,
  refetch,
  icon = <DownloadIcon fontSize="small" />,
  ...rest
}) => {
  return (
    <IconButton
      size="small"
      onClick={() => refetch()}
      {...rest}
      disabled={isFetching || disabled}
    >
      {isFetching ? <CircularProgress size={20} color="inherit" /> : icon}
    </IconButton>
  )
}
